/**
 * Links from the Teams app to the stand-alone browser panels (Admin, Risk
 * Management, SysOps). Used by the user menu and by the landing page shown to
 * people whose roles have no module in this app.
 */
import { app } from '@microsoft/teams-js';

/** The stand-alone browser panels (not part of Teams). Each link shows only to the roles that
 *  panel's own RoleGate admits, so nobody is sent to an "access denied" page. Interim per Bill
 *  2026-10-07 - Risk will not work inside the Teams app going forward; this saves hunting for
 *  the address. Keep these role lists in step with each panel's RoleGate.tsx. */
export const PANEL_LINKS: ReadonlyArray<{ label: string; url: string; roles: ReadonlySet<string> }> = [
  { label: 'Open the Admin panel', url: 'https://admin.mypcb.com/',
    roles: new Set(['superadmin', 'admin', 'retailadmin', 'sysopsmanager', 'riskmanager', 'disclosuremanager']) },
  { label: 'Open the Risk Management panel', url: 'https://risk.mypcb.com/',
    roles: new Set(['riskmanager', 'superadmin']) },
  { label: 'Open the SysOps panel', url: 'https://sysops.mypcb.com/',
    roles: new Set(['systemops', 'superadmin']) },
];

export function openInBrowser(url: string): void {
  try {
    // Teams opens external links in the default browser (Edge); outside Teams fall back to a new tab.
    const openLink = (app as unknown as { openLink?: (u: string) => Promise<void> }).openLink;
    if (typeof openLink === 'function') { void openLink(url); return; }
  } catch { /* not initialised - fall through */ }
  window.open(url, '_blank', 'noopener,noreferrer');
}

/** The panels a person can open, for their role codes (any case). */
export function panelLinksForRoles(roles: ReadonlyArray<string>): ReadonlyArray<(typeof PANEL_LINKS)[number]> {
  const mine = roles.map((r) => String(r).toLowerCase());
  return PANEL_LINKS.filter((p) => mine.some((r) => p.roles.has(r)));
}
